'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SURROGATE_HATEOAS_TYPE_PREFIX = undefined;
exports.default = createHateoasModel;
exports.createReadOnlyModel = createReadOnlyModel;

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _pagedCollectionFactory = require('./paged/pagedCollectionFactory');

var _pagedCollectionFactory2 = _interopRequireDefault(_pagedCollectionFactory);

var _utils = require('./utils');

var _BackendSyncState = require('./BackendSyncState');

var _BackendSyncState2 = _interopRequireDefault(_BackendSyncState);

var _serverErrors = require('./serverErrors');

var _EmptyParametersModel = require('./paged/EmptyParametersModel');

var _EmptyParametersModel2 = _interopRequireDefault(_EmptyParametersModel);

var _NavigationModel = require('./paged/NavigationModel');

var _NavigationModel2 = _interopRequireDefault(_NavigationModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var SURROGATE_HATEOAS_TYPE_PREFIX = exports.SURROGATE_HATEOAS_TYPE_PREFIX = '#surrogate#';

var DEFAULT_SEARCH_METHOD = 'find';
var DEFAULT_RAW_NAVIGATION = {
    pageNumber: 0,
    sort: [{
        direction: 'desc',
        property: 'id'
    }]
};

var addLinkMethod = function addLinkMethod(model) {
    model.getLink = function (name) {
        return {
            value: model[name],
            requestChange: function requestChange(value) {
                model[name] = value;
            }
        };
    };
};

var HateoasModel = Nested.Model.extend({
    initialize: function initialize() {
        this.postInitialize();
    },
    postInitialize: function postInitialize() {
        this._backendSyncState = new _BackendSyncState2.default();
        this._backendSyncState.model = this;

        // work around for cached collection initialization
        if (this.id === -1) {
            return;
        }

        this.domain.getCache().addEntity(this);

        !this.getLink && addLinkMethod(this);

        (0, _serverErrors.addServerErrorsIntegration)(this);
    },


    /**
     * integration with nestedTypes
     */
    getStore: function getStore() {
        return this.domain.getCache().getCacheStore();
    },
    getBackendSyncState: function getBackendSyncState() {
        return this._backendSyncState;
    },
    sync: function sync(method, model, options) {
        if (method === 'read') {
            return this._readModel(model, options);
        } else if (method === 'create') {
            return this._createModel(model, options);
        } else if (method === 'update') {
            return this._updateModel(model, options);
        } else if (method === 'delete') {
            return this._deleteModel(model, options);
        }

        throw new Error('unsupported method ' + method);
    },
    _readModel: function _readModel(model, options) {
        var _this = this;

        var hateoasBaseUrl = this.domain.baseUrl;
        var type = model.hateoasType;
        var url = hateoasBaseUrl + '/' + type + '/' + model.id;

        var syncResult = this.superAgent.get(url).accept('application/hal+json;charset=UTF-8').then(_utils.checkHttpCode).then(function (response) {
            return (0, _utils.normalizeModel)(_this.domain, response.body, _this.superAgent);
        }).then(function (result) {
            options.success(result);
            return null; // prevent bluebird "forget to return" warning
        }, function (error) {
            options.error(error);
            throw error;
        });

        this._backendSyncState._startFetch(syncResult);

        return (0, _utils.promise2jqueryPromise)(syncResult);
    },
    _createModel: function _createModel(model, options) {
        var _this2 = this;

        var hateoasBaseUrl = this.domain.baseUrl;
        var type = model.hateoasType;
        var url = hateoasBaseUrl + '/' + type;

        var syncResult = this.superAgent.post(url).accept('application/hal+json;charset=UTF-8').set('Content-Type', 'application/hal+json').send(model.toJSON()).then(_utils.checkHttpCode).then(function (response) {
            // todo: review references reFetch (set id and skip other operations)
            return (0, _utils.normalizeModel)(_this2.domain, response.body, _this2.superAgent);
        }).then(function (result) {
            options.success(result);
            return null; // prevent bluebird "forget to return" warning
        }).then(function () {
            _this2.domain.getCache().invalidateCollections(type);
        }, function (error) {
            options.error(error);
            (0, _serverErrors.applyServerErrorsIfAccepted)(model, error);
            throw error;
        });

        this._backendSyncState._startSave(syncResult);

        return (0, _utils.promise2jqueryPromise)(syncResult);
    },
    _updateModel: function _updateModel(model, options) {
        var _this3 = this;

        var hateoasBaseUrl = this.domain.baseUrl;
        var type = model.hateoasType;
        var url = hateoasBaseUrl + '/' + type + '/' + model.id;

        var syncResult = this.superAgent.patch(url).accept('application/hal+json;charset=UTF-8').set('Content-Type', 'application/hal+json').send(model.toJSON()).then(_utils.checkHttpCode).then(function (response) {
            // todo: review references reFetch (skip?)
            return (0, _utils.normalizeModel)(_this3.domain, response.body, _this3.superAgent);
        }).then(function (result) {
            options.success(result);
        }, function (error) {
            options.error(error);
            (0, _serverErrors.applyServerErrorsIfAccepted)(model, error);
            throw error;
        });

        this._backendSyncState._startSave(syncResult);

        return (0, _utils.promise2jqueryPromise)(syncResult);
    },
    _deleteModel: function _deleteModel(model, options) {
        var _this4 = this;

        var hateoasBaseUrl = this.domain.baseUrl;
        var type = model.hateoasType;
        var url = hateoasBaseUrl + '/' + type + '/' + model.id;

        var syncResult = this.superAgent.delete(url).set('Content-Type', 'application/hal+json').then(_utils.checkHttpCode).then(function (result) {
            options.success(result);
            return null; // prevent bluebird "forget to return" warning
        }).then(function () {
            _this4.domain.getCache().invalidateCollections(type);
        }, function (error) {
            options.error(error);
            throw error;
        });

        this._backendSyncState._startDelete(syncResult);

        return (0, _utils.promise2jqueryPromise)(syncResult);
    },
    toJSON: function toJSON() {
        return (0, _utils.convertModel2Json)(this);
    }
}, {
    /**
     *
     * @param options
     * @param options.name new method name
     * @param [options.query] search model, if no provided - use empty model
     * @param [options.navigation] default navigation
     * @param [options.overrideUrl] for some method custom url required
     */
    defineSearchMethod: function defineSearchMethod(options) {
        var _this5 = this;

        this._searchMethods = this._searchMethods || {};
        var ParametersModel = options.query || _EmptyParametersModel2.default;
        var AdditionalInfo = options.additionalInfo || _EmptyParametersModel2.default;
        var overrideUrl = options.overrideUrl;

        var methodName = options.name || DEFAULT_SEARCH_METHOD;
        var defaultRawNavigation = options.navigation || {};

        if (this._searchMethods[methodName]) {
            throw new Error('search method \'' + methodName + '\' already defined on Model ' + this.hateoasType);
        }

        if (this[methodName]) {
            throw new Error('method \'' + methodName + '\' already defined on Model ' + this.hateoasType);
        }

        var defaultFind = methodName === 'find';

        // 1 - url
        var url = void 0;
        var hateoasBaseUrl = this.domain.baseUrl;
        var hateoasType = this.hateoasType;
        if (defaultFind && !overrideUrl) {
            // `find` - is special case, use default spring-data-rest list search
            url = hateoasBaseUrl + '/' + hateoasType;
        } else {
            if (overrideUrl) {
                url = overrideUrl;
            } else {
                if (hateoasType.startsWith(SURROGATE_HATEOAS_TYPE_PREFIX)) {
                    throw new Error('can\'t define contextual search method for read-only entity');
                }
                url = hateoasBaseUrl + '/' + hateoasType + '/search/' + methodName;
            }
        }
        url = (0, _utils.toAbsoluteUrl)(this.domain.applicationUrl, url);

        // 2 - collection constructor
        var PagedCollectionConstructor = (0, _pagedCollectionFactory2.default)(this, this.superAgent, url);

        // 3 - create search function
        var searchFunction = function searchFunction() {
            var searchOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var key = searchOptions.key || 'default-collection';
            var rawParameters = searchOptions.parameters || {};
            var rawNavigation = searchOptions.navigation || {};

            var navigation = new _NavigationModel2.default(_underscore2.default.defaults({}, rawNavigation, defaultRawNavigation, DEFAULT_RAW_NAVIGATION));
            var parameters = new ParametersModel(rawParameters);
            var additionalInfo = new AdditionalInfo();

            !parameters.getLink && addLinkMethod(parameters);

            (0, _serverErrors.addServerErrorsIntegration)(parameters);

            return _this5.domain.getCache().getPagedCollection({
                PagedCollectionConstructor: PagedCollectionConstructor,
                key: key,
                methodName: methodName,
                navigation: navigation,
                parameters: parameters,
                additionalInfo: additionalInfo
            });
        };

        this._searchMethods[methodName] = searchFunction;
        this[methodName] = searchFunction;

        return this; // for methods declaration chaining
    }
});

/**
 * create new hateoasModel with app-specific props
 */
function createHateoasModel(className, hateoasType, domain) {
    var extendedProtoProps = {};
    var extendedStaticProps = {};

    extendedProtoProps.collection = {
        sync: function sync() {
            throw new Error('use Model.search.xxx or Model.find');
        }
    };
    extendedProtoProps.className = className;
    extendedProtoProps.superAgent = domain.superAgent;
    extendedProtoProps.domain = domain;
    extendedProtoProps.hateoasType = hateoasType;

    extendedStaticProps.className = className;
    extendedStaticProps.superAgent = domain.superAgent;
    extendedStaticProps.domain = domain;
    extendedStaticProps.hateoasType = hateoasType;
    extendedStaticProps.search = {};

    var Model = HateoasModel.extend(extendedProtoProps, extendedStaticProps);

    Model.defineSearchMethod({
        name: 'find'
    });

    return Model;
}

function createReadOnlyModel(className, domain) {
    var extendedProtoProps = {};
    var extendedStaticProps = {};

    extendedProtoProps.collection = {
        sync: function sync() {
            throw new Error('use Model.createPagedCollection');
        }
    };
    extendedProtoProps.superAgent = domain.superAgent;
    extendedProtoProps.domain = domain;
    extendedProtoProps.className = className;
    extendedProtoProps.hateoasType = SURROGATE_HATEOAS_TYPE_PREFIX + className;

    extendedStaticProps.superAgent = domain.superAgent;
    extendedStaticProps.domain = domain;
    extendedStaticProps.className = className;
    extendedStaticProps.hateoasType = SURROGATE_HATEOAS_TYPE_PREFIX + className;
    extendedStaticProps.search = {};

    return HateoasModel.extend(extendedProtoProps, extendedStaticProps);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/hateoasModelFactory.js
// module id = 734
// module chunks = 118